/**
 * Global content search across every channel the user can see.
 */
import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { ArrowLeft, Search as SearchIcon, Loader2 } from "lucide-react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import "./studio.css";

const API = process.env.REACT_APP_BACKEND_URL || '';

export default function StudioSearch() {
  const [q, setQ] = useState("");
  const [busy, setBusy] = useState(false);
  const [items, setItems] = useState(null);

  const run = async (e) => {
    e?.preventDefault();
    if (q.trim().length < 2) return;
    setBusy(true);
    try {
      const r = await axios.get(`${API}/api/studio/search`, {
        withCredentials: true, params: { q: q.trim() },
      });
      setItems(r.data.items || []);
    } catch (_) { setItems([]); }
    finally { setBusy(false); }
  };

  return (
    <>
      <Header />
      <div className="studio-shell">
        <Link to="/studio" className="studio-back" data-testid="search-back">
          <ArrowLeft size={14}/> Back to Studio
        </Link>
        <div style={{ marginTop: 12 }}>
          <span className="studio-eyebrow"><SearchIcon size={12}/> Global search</span>
          <h2 style={{ margin: "6px 0 18px" }}>Find any video across every channel</h2>
        </div>
        <form onSubmit={run} className="studio-card" style={{ display: "flex", gap: 10 }}>
          <input
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Search by title, script content, or keyword"
            style={{ flex: 1, padding: "10px 12px", background: "#FFFFFF", border: "1px solid #E2E8F0", color: "#0F172A", borderRadius: 10 }}
            data-testid="search-input"
          />
          <button type="submit" className="studio-btn-primary" disabled={busy} data-testid="search-go">
            {busy ? <Loader2 size={14} className="ac-spin"/> : <SearchIcon size={14}/>} Search
          </button>
        </form>

        {items !== null && (
          <div style={{ marginTop: 18 }}>
            {items.length === 0 ? (
              <p className="studio-muted">No matches.</p>
            ) : (
              <ul className="studio-ops-list" data-testid="search-results">
                {items.map((it) => (
                  <li key={it._id} className="studio-ops-li">
                    <Link to={`/studio/channels/${it.channel_id}#content-${it._id}`} data-testid={`search-result-${it._id}`}>
                      <strong>{it.title}</strong>
                      <span>{it.type} · {it.stage}</span>
                    </Link>
                  </li>
                ))}
              </ul>
            )}
          </div>
        )}
      </div>
      <Footer />
    </>
  );
}
